export default __webpack_public_path__ + "static/schoolbusExterior-d0a11377d53cc08fe57e67f4c93edcd5.svg";